<template>
    <CustomHeader :text="$t('bonus.playersInvited')" />
    <div class="container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
            <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index">
                <div class="content">
                    <div>
                        <div class="table_container">
                            <van-row class="tabel_head">
                                <van-col span="5" class="tabel_alignment">{{ $t('bonus.player') }}</van-col>
                                <van-col span="2" class="tabel_alignment">
                                    <div class="line"></div>
                                </van-col>
                                <van-col span="4" class="tabel_alignment">{{ $t('bonus.invitationDate') }}</van-col>
                                <van-col span="2" class="tabel_alignment">
                                    <div class="line"></div>
                                </van-col>
                                <van-col span="4" class="tabel_alignment">{{ $t('dayList.giftAmount') }}</van-col>
                                <van-col span="2" class="tabel_alignment">
                                    <div class="line"></div>
                                </van-col>
                                <van-col span="5" class="tabel_alignment">{{ $t('bonus.status') }}</van-col>
                            </van-row>

                            <van-row class="tabel_row" v-for="(item, index) in dataSet.playersList" :key="index" :style="{
                                backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                            }">
                                <van-col span="6" class="tabel_alignment">{{ item.uid }}</van-col>
                                <van-col span="6" class="tabel_alignment">{{ item.createTime }}</van-col>
                                <van-col span="6" class="tabel_alignment">{{ item.rewardAmount }}</van-col>
                                <van-col span="6" class="tabel_alignment">{{ }}
                                    <p v-if="item.claimStatus == 0" style="color: #0484ff;">{{
                                        $t('activityStatus.pending') }}</p>
                                    <p v-else-if="item.claimStatus == 1" style="color: #36d836;">{{
                                        $t('activityStatus.active')
                                        }}</p>
                                    <p v-else-if="item.claimStatus == 2" style="color: #ff0000;">{{
                                        $t('activityStatus.inactive')
                                        }}</p>
                                </van-col>
                            </van-row>

                        </div>
                    </div>
                    <div v-if="dataSet.playersList.length <= 0">
                        <NoData />
                    </div>
                    <div v-else>
                        <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageMsgList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('message.noMore') }}</div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script setup lang="ts">
import { computed,  ref, defineEmits, defineProps } from 'vue'; 
import CustomHeader from '../../components/common/customHeader.vue';
import NoData from '../../components/common/noData.vue';
import { ChestUserData, TAB_LIST } from '@/view/activeChest/supportScript';

const tabList = computed(() => TAB_LIST)
const active = ref(0);

const props = defineProps<{
  dataSet: ChestUserData
}>()
const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const onClickTab = (active: any) => {
    emits('onClickTab',active)
}
const getNextPageMsgList = () => {
     emits('getNextPageMsgList')
}

</script>
<style scoped>
.container {
    padding: 70px 0;

}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.tabel_head {
    padding: 20px 10px;
    background: rgba(255, 255, 255, 0.25);
    box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
    border-radius: 10px 10px 0 0;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    font-size: 14px;
}

.tabel_alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.tabel_row {
    color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
}

.tabel_row .van-col {
    padding: 10px 0;
    color: rgba(255, 255, 255, 0.65);
}

.table_container {
    margin-top: 5px;
}

.line {
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
    height: 10px;
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}
</style>